import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/store';
import GeneralRoutes from './routes/general.routes.js';
import UserRoutes from './routes/user.routes.js';
import ProfessionRoutes from './routes/profession.routes.js';
import StepRoutes from './routes/step.routes.js';
import SectionRoutes from './routes/section.routes.js';
import PageRoutes from './routes/page.routes.js';
import CardRoutes from './routes/card.routes.js';
import FieldRoutes from './routes/field.routes.js';
import PopulationRoutes from './routes/population.routes.js';
import SiteRoutes from './routes/site.routes.js';
import PaletteRoutes from './routes/palette.routes.js';
import FontPairingRoutes from './routes/fontPairing.routes.js';
import SettingRoutes from './routes/settings.routes';
import FaqRoutes from './routes/faq.routes';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        ...UserRoutes,
        ...ProfessionRoutes,
        ...GeneralRoutes,
        ...StepRoutes,
        ...SectionRoutes,
        ...PageRoutes,
        ...CardRoutes,
        ...FieldRoutes,
        ...PopulationRoutes,
        ...SiteRoutes,
        ...PaletteRoutes,
        ...FontPairingRoutes,
        ...SettingRoutes,
        ...FaqRoutes,
    ],

    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach((to, from, next) => {
    // Route does not require auth, proceed to destination.
    if (!to.matched.some((record) => record.meta.requiresAuth)) next();

    // Route requires auth.
    else {
        // Dispatch Authentication.
        store.commit('overlay/toggle', true);
        store.dispatch('auth/me')
            .then(() => {
                const authenticated = store.getters['auth/authenticated'];
                const user = store.getters['auth/user'];

                if (!user) {
                    next({ name: 'Login' });
                }

                // Not authenticated, redirect to login.
                if (!authenticated) {
                    if (to.name !== 'Auth') next({ name: 'Login' });
                    else next();
                }

                const role = user.role;

                if (role === 'builder') {
                    if (to.name !== 'Dashboard' && to.name !== 'SiteSingle') next({ name: 'Dashboard' });
                    else next();
                } else {
                    if (to.name === 'Auth' || to.name === 'Register') next({ name: 'Dashboard' });
                    else next();
                }
            });
    }
});

export default router;
